import { AxiosError, AxiosResponse } from 'axios';
import {
    ETrackingEventsName,
    ITrackingRequestData,
    ITrackingScreenData,
    ITrackingUserInteraction,
} from '../../models/Tracking.interfaces';
import sendAnalyticsToNative from '../navigation/sendAnalyticsToNative';
import { setInfoError } from './errorMesssages';
import { screens } from './screenTags';

const getTrackingRequest = (data: any, result: string) => {
    const baseUrl = data.config.baseURL!;
    const url = data.config.url!;
    const endpointUrl = (baseUrl + url.split('?')[0]).toString();
    const method = data.config.method!.toUpperCase().toString();
    const httpStatus = `${data?.status || data?.response?.status}`;
    const screen = window.location.pathname.split('?')[0].toString();
    const screenName: string = screens[screen];
    let response: ITrackingRequestData = {
        screenName,
        endpointUrl,
        method,
        result,
        httpStatus,
    };

    return response;
};

const sendAnalytics = (response: any) => {
    sendAnalyticsToNative(ETrackingEventsName.API_REQUEST, response);
};

const handleTrackingRequestSuccess = (response: AxiosResponse) => {
    sendAnalytics(getTrackingRequest(response, 'SUCCESS'));
};

const handleTrackingRequestError = (error: AxiosError) => {
    const { id } = setInfoError(error);
    sendAnalytics({ ...getTrackingRequest(error, 'ERROR'), errorCode: `${id}` });
};

class TrackingEvents {
    public trackingScreenView(url?: string) {
        const screen =
            url ??
            window.location.pathname
                .split('?')[0]
                .split('/')
                .filter((item) => !Number(item))
                .join('/');

        const data: ITrackingScreenData = {
            screenName: screens[screen!],
        };
        if (screens[screen!]) {
            sendAnalyticsToNative(ETrackingEventsName.SCREEN_VIEW, data);
        }
    }

    public trackingApiRequest(response: any, type: 'SUCCESS' | 'ERROR') {
        const tracking: {
            SUCCESS: (response: AxiosResponse) => void;
            ERROR: (response: any) => void;
        } = {
            SUCCESS: handleTrackingRequestSuccess,
            ERROR: handleTrackingRequestError,
        };

        tracking[type](response);
    }
    public trackingUserInteraction(id: string, url?: string) {
        const screen =
            url ??
            window.location.pathname
                .split('?')[0]
                .split('/')
                .filter((item) => !Number(item))
                .join('/');
        const data: ITrackingUserInteraction = { screenName: screens[screen!], id: id };
        sendAnalyticsToNative(ETrackingEventsName.USER_INTERACTION, data);
    }
}

export { handleTrackingRequestSuccess, handleTrackingRequestError, TrackingEvents };
